export const ROW_ACTIONS = {
  OPEN_RECORD: "open-record",
  EDIT_RECORD: "edit-record",
  DELETE_RECORD: "delete-record",
  SELECT_RECORD: "select-record",
  DOWNLOAD_RECORD: "download-record",
  PLAY_RECORD: "play-record",
  TRANSCRIBE: "transcribe",
  VIEW_TRANSCRIPT: "view-transcript",
  COPY: "copy"
};

// New form status constants
export const FORM_STATUS = {
  OVERRIDDEN: "overridden",
  PENDING: "pending",
  SEND_FORM: "send-form",
  COMPLETED: "completed",
  NOT_SUBMITTED: "not-submitted",
  APPROVED: "approved",
  REJECTED: "rejected",
  NOT_ASSIGNED: "not-assigned",
  NOT_SENT: "not-sent"
};
